export default __webpack_public_path__ + "static/media/ic-csv.a9557e7c.svg";